import React, {useEffect, useState} from 'react'
import {BasicLayout} from '../../../modules/Layouts/basicLayout'
import {useHistory} from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import {State} from '../../../reducers'
import {gc_ec_Clear} from '../../../actions/gestion-cliente/editar-cliente/editarCliente.actions'
import {actionsGCEditarCliente} from '../../../actions/action-creators'
import SearchSelect from '../../../components/Inputs/SearchSelect'
import InputPhone from '../../../components/Inputs/InputPhone'
import {isNullOrEmpty} from '../../../utils/strings.utils'
import InputChips from '../../OtrosDocumentos/Components/InputChips'
import {avisoDistritoPendiente, esNormativaV2} from '../../../utils/normativa.utils'
import AvisoVerificacionDatos from '../../../components/AvisoVerificacionDatos/AvisoVerificacionDatos'
import {verificacionesPendientesDe} from '../../../utils/verificacion-datos.utils'

const EditarCliente = () => {
  const clienteSeleccionado = useSelector(
    (state: State) => state.gestionCliente.editarCliente.clienteSeleccionado
  )
  const formCliente = useSelector((state: State) => state.gestionCliente.editarCliente.formCliente)
  const verificaciones = useSelector(
    (state: State) => state.gestionCliente.listarClientes.verificaciones
  )
  const errors = useSelector((state: State) => state.gestionCliente.editarCliente.errorsFormCliente)
  const {tipoDocumento, departamentos, municipios, distritos, actividadesEconomicas, datosEmisor} =
    useSelector((state: State) => state.catalogos)
  const normativaV2 = esNormativaV2(datosEmisor)
  const avisoDistrito = avisoDistritoPendiente(datosEmisor, formCliente?.distrito)
  const verificacionesCliente = verificacionesPendientesDe(
    verificaciones,
    clienteSeleccionado?.idcliente
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const actionsEditar = bindActionCreators(actionsGCEditarCliente, dispatch)

  const [catalogoTipoDocumento, setCatalogoTipoDocumento] = useState(tipoDocumento)
  const [catalogueActividadEconomica, setCatalogueActividadEconomica] = useState(
    actividadesEconomicas.map((tipo) => ({
      ...tipo,
      codigo_nombre: `${tipo.codigo} - ${tipo.valor}`,
    }))
  )

  useEffect(() => {
    window.scroll(0, 0)
    if (!clienteSeleccionado) {
      history.push('/gestion-clientes/listar-clientes')
    }
    return () => {
      dispatch(gc_ec_Clear())
    }
  }, [])

  const handleVolver = () => {
    dispatch(gc_ec_Clear())
    history.push('/gestion-clientes/listar-clientes')
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement> | any) => {
    actionsEditar.gc_ec_HandleFormChange(e)
  }

  const handleBlur = (e: any) => {
    // Handler para validaciones en blur si es necesario
  }

  const submit = async (e: any) => {
    e.preventDefault()
    await actionsEditar.gc_ec_UpdateClienteConfirm(() =>
      history.push('/gestion-clientes/listar-clientes')
    )
  }

  return (
    <BasicLayout>
      <div className='header'>
        <button className='back-button w-inline-block' onClick={handleVolver}></button>
        <h3 className='h3-titles xl'>Editar Cliente</h3>
      </div>
      <div className='separador'></div>
      <form className='card w-form w-100 mt-16' autoComplete='off' onSubmit={submit}>
        <div className='card-basic w-100'>
          <div className='mb-16'>
            <h3 className='card-title l mb-16'>Información del cliente</h3>
            <div className='separador' style={{opacity: '10%'}}></div>
          </div>
          {verificacionesCliente.length > 0 && (
            <div className='mb-16'>
              <AvisoVerificacionDatos
                verificaciones={verificacionesCliente}
                introduccion='Corrija los datos que se indican abajo y guarde los cambios. Si ya los revisó y están correctos, puede quitar la advertencia desde el listado de clientes.'
              />
            </div>
          )}
          <div className='mt-16'>
            <div className='form-content'>
              {/*Fila 1*/}
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='tipoDocumento' className='field-label m'>
                    Tipo de documento de identificación<span style={{color: 'red'}}>*</span>
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={false}
                    placeholder='Tipo de Identificación'
                    value={formCliente?.tipoDocumento}
                    name='tipoDocumento'
                    data={catalogoTipoDocumento}
                    keyNameText='valor'
                    keyNameValue='codigo'
                    onChange={(value: any) => {
                      handleChange({
                        target: {value: value?.value, name: 'tipoDocumento'},
                      })
                    }}
                  />
                  {errors?.tipoDocumento && <p className='alert s'>{errors.tipoDocumento}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='numId' className='field-label m'>
                    {formCliente?.nombreTipoDocumento || 'Número de identificación'}
                    <span style={{color: 'red'}}>*</span>
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='numId'
                    data-name='numId'
                    placeholder={`Número de ${formCliente?.nombreTipoDocumento || 'Identificación'}`}
                    id='numId'
                    disabled={false}
                    maxLength={20}
                    value={formCliente?.numId ?? ''}
                    onChange={handleChange}
                  />
                  {errors?.numId && <p className='alert s'>{errors.numId}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='nombre' className='field-label m'>
                    Nombre del cliente<span style={{color: 'red'}}>*</span>
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='nombre'
                    data-name=''
                    placeholder='Nombre del cliente'
                    id='nombre'
                    disabled={false}
                    maxLength={250}
                    value={formCliente?.nombre ?? ''}
                    onChange={handleChange}
                  />
                  {errors?.nombre && <p className='alert s'>{errors.nombre}</p>}
                </div>
              </div>

              {/*Fila 2*/}
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='departamento' className='field-label m'>
                    Departamento
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={formCliente?.tipoDocumento ? false : true}
                    placeholder='Departamento'
                    value={formCliente?.departamento}
                    name='departamento'
                    data={departamentos?.map((dep) => ({
                      ...dep,
                      codigo_nombre: `${dep.codigo} - ${dep.valor}`,
                    }))}
                    keyNameText='codigo_nombre'
                    keyNameValue='codigo'
                    onChange={(value: any) => {
                      handleChange({
                        target: {value: value?.value, name: 'departamento'},
                      })
                    }}
                  />
                  {errors?.departamento && <p className='alert s'>{errors.departamento}</p>}
                </div>

                <div className='label-input'>
                  <label htmlFor='municipio' className='field-label m'>
                    Municipio
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={
                      isNullOrEmpty(formCliente?.departamento)
                        ? true
                        : formCliente?.tipoDocumento
                        ? false
                        : true
                    }
                    placeholder='Municipio'
                    value={formCliente?.municipio}
                    name='municipio'
                    data={municipios?.map((mun) => ({
                      ...mun,
                      codigo_nombre: `${mun?.codigo} - ${mun?.valor}`,
                    }))}
                    keyNameText='codigo_nombre'
                    keyNameValue='codigo'
                    onChange={(value: any) => {
                      handleChange({
                        target: {value: value?.value, name: 'municipio'},
                      })
                    }}
                  />
                  {errors?.municipio && <p className='alert s'>{errors.municipio}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='direccion' className='field-label m'>
                    Dirección
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='direccion'
                    data-name=''
                    placeholder='Dirección'
                    id='direccion'
                    disabled={
                      isNullOrEmpty(formCliente?.municipio)
                        ? true
                        : formCliente?.tipoDocumento
                        ? false
                        : true
                    }
                    maxLength={200}
                    value={formCliente?.direccion ?? ''}
                    onChange={handleChange}
                  />
                  {errors?.direccion && <p className='alert s'>{errors.direccion}</p>}
                </div>
              </div>

              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='distrito' className='field-label m'>
                    Distrito
                    {normativaV2 && !isNullOrEmpty(formCliente?.departamento) && (
                      <span style={{color: 'red'}}>*</span>
                    )}
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={isNullOrEmpty(formCliente?.departamento) ? true : false}
                    placeholder='Distrito'
                    value={formCliente?.distrito}
                    name='distrito'
                    data={distritos?.map((dis) => ({
                      ...dis,
                      codigo_nombre: `${dis?.codigo} - ${dis?.valor}`,
                    }))}
                    keyNameText='codigo_nombre'
                    keyNameValue='codigo'
                    onChange={(value: any) => {
                      handleChange({
                        target: {value: value?.value, name: 'distrito'},
                      })
                    }}
                  />
                  {avisoDistrito && !errors?.distrito && (
                    <p className='alert s'>{avisoDistrito}</p>
                  )}
                  {errors?.distrito && <p className='alert s'>{errors.distrito}</p>}
                </div>
                <div className='label-input'></div>
                <div className='label-input'></div>
              </div>

              {/*Fila 3*/}
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <InputChips
                    maxChips={5}
                    chips={formCliente?.chipsEmail}
                    setChips={(chipsEmail: Array<string>) =>
                      handleChange({target: {value: chipsEmail, name: 'chipsEmail'}})
                    }
                    maxLength={100}
                    name='email'
                    placeholder='Correo electrónico'
                    label='Correo electrónico'
                    disabled={formCliente?.tipoDocumento ? false : true}
                    value={formCliente?.email ?? ''}
                    onChange={handleChange}
                  />
                  {errors?.email && <p className='alert s'>{errors.email}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='telefono' className='field-label m'>
                    Teléfono celular
                  </label>
                  <InputPhone
                    disabled={formCliente?.tipoDocumento ? false : true}
                    value={formCliente?.telefono}
                    onChange={(value: any) =>
                      handleChange({
                        target: {value, name: 'telefono'},
                      })
                    }
                    onBlur={handleBlur}
                    className='telefono-style'
                    name='telefono'
                  />
                  {errors?.telefono && <p className='alert s'>{errors.telefono}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='actividad' className='field-label m'>
                    Actividad
                  </label>
                  <SearchSelect
                    defaultValue={null}
                    disabled={formCliente?.tipoDocumento ? false : true}
                    placeholder='Actividad económica'
                    value={formCliente?.actividad}
                    name='actividad'
                    data={catalogueActividadEconomica}
                    keyNameText='codigo_nombre'
                    keyNameValue='codigo'
                    onChange={(value: any) => {
                      handleChange({
                        target: {value: value?.value, name: 'actividad'},
                      })
                    }}
                  />
                  {errors?.actividad && <p className='alert s'>{errors.actividad}</p>}
                </div>
              </div>

              {/*Fila 4*/}
              <div className='w-layout-hflex h-inputs'>
                <div className='label-input'>
                  <label htmlFor='nrc' className='field-label m'>
                    NRC
                  </label>
                  <input
                    autoComplete='off'
                    type='text'
                    className='m text-field w-input'
                    name='nrc'
                    data-name='nrc'
                    placeholder='NRC'
                    id='nrc'
                    maxLength={7}
                    value={formCliente?.nrc ?? ''}
                    onChange={handleChange}
                  />
                  {errors?.nrc && <p className='alert s'>{errors.nrc}</p>}
                </div>
                <div className='label-input'>
                  <label htmlFor='correocc' className='field-label m'>
                    Correo CC (copia)
                  </label>
                  <input
                    autoComplete='off'
                    type='email'
                    className='m text-field w-input'
                    name='correocc'
                    data-name='correocc'
                    placeholder='Correo para copia (CC)'
                    id='correocc'
                    disabled={formCliente?.tipoDocumento ? false : true}
                    maxLength={100}
                    value={formCliente?.correocc ?? ''}
                    onChange={handleChange}
                  />
                </div>
                <div className='label-input'></div>
              </div>
            </div>
          </div>
        </div>
        <div className='separador mt-16'></div>
        <div
          className='mt-16 w-100 button-actions'
          style={{display: 'flex', justifyContent: 'space-between'}}
        >
          <button
            type='button'
            className='m button transparent w-inline-block w-auto'
            onClick={handleVolver}
          >
            <div>Cancelar</div>
          </button>
          <button type='submit' className='m button w-inline-block w-auto'>
            <div>Guardar Cambios</div>
          </button>
        </div>
      </form>
    </BasicLayout>
  )
}

export default EditarCliente
